import React, { useState, useCallback } from 'react';

import LoginContainer from './LoginContainer';
import { LOGIN_FORM, FORGOT_PASSWORD_FORM } from '../../constants';

function LoginContainerVM(props) {
  const flagNewTiers = !!window?.FLAGS?.NewTiers;
  const [currentForm, setCurrentForm] = useState(LOGIN_FORM);

  const setFormView = useCallback(() => {
    if (currentForm === LOGIN_FORM) {
      setCurrentForm(FORGOT_PASSWORD_FORM);
      return;
    }
  
    setCurrentForm(LOGIN_FORM);
  }, [currentForm]);

  const descriptionText = flagNewTiers
    ? 'A world of rewards and access.'
    : 'Welcome to a whole new world of rewards and access.';

  return (
    <LoginContainer
      {...props}
      descriptionText={descriptionText}
      formView={currentForm}
      setFormView={setFormView}
    />
  );
}

export default LoginContainerVM;
